/** Validate the Git-based Manager v2 snapshot contract supported by the server resolver. */
export function parseSupportedComfySnapshot(serialized: string): string {
    const snapshot: unknown = JSON.parse(serialized);
    const isObject = (value: unknown): value is Record<string, any> =>
        value !== null && typeof value === "object" && !Array.isArray(value);
    const isCommit = (value: unknown) => typeof value === "string" && /^[a-f0-9]{40}$/i.test(value);

    if (!isObject(snapshot) || !isCommit(snapshot.comfyui)) {
        throw new Error("ComfyUI returned an invalid snapshot revision. The recipe was not saved.");
    }
    if (snapshot.cnr_custom_nodes !== undefined &&
        (!isObject(snapshot.cnr_custom_nodes) || Object.keys(snapshot.cnr_custom_nodes).length > 0)) {
        throw new Error("Comfy Registry nodes require a reviewed conversion to pinned Git nodes before saving.");
    }
    if (snapshot.git_custom_nodes !== undefined &&
        (!isObject(snapshot.git_custom_nodes) || Object.values(snapshot.git_custom_nodes).some(
            node => !isObject(node) || !isCommit(node.hash)))) {
        throw new Error("ComfyUI returned invalid Git node revisions. The recipe was not saved.");
    }
    if (snapshot.file_custom_nodes !== undefined &&
        (!Array.isArray(snapshot.file_custom_nodes) || snapshot.file_custom_nodes.length > 0)) {
        throw new Error("Standalone file nodes require a reviewed conversion to pinned Git nodes before saving.");
    }
    return JSON.stringify(snapshot);
}
